import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { maxDailyShows: Number }

  connect() {
    this.checkAndShow()
  }

  checkAndShow() {
    const today = new Date().toDateString()
    const storageKey = "prompt_dialog_shows"
    const stored = JSON.parse(localStorage.getItem(storageKey) || "{}")

    if (stored.date !== today) {
      stored.date = today
      stored.count = 0
    }

    if (stored.count < this.maxDailyShowsValue) {
      this.show()
      stored.count++
      localStorage.setItem(storageKey, JSON.stringify(stored))
      this.trackShow()
    } else {
      this.element.classList.add("hidden")
    }
  }

  show() {
    this.element.classList.remove("hidden")
  }

  close() {
    this.element.classList.add("hidden")
    this.trackClose()
  }

  trackClick() {
    if (typeof gtag === "function") {
      gtag("event", "prompt_dialog_click", {
        event_category: "engagement",
        event_label: "work_history_prompt"
      })
    }
  }

  trackShow() {
    if (typeof gtag === "function") {
      gtag("event", "prompt_dialog_show", {
        event_category: "engagement",
        event_label: "work_history_prompt"
      })
    }
  }

  trackClose() {
    if (typeof gtag === "function") {
      gtag("event", "prompt_dialog_close", {
        event_category: "engagement",
        event_label: "work_history_prompt"
      })
    }
  }
}
